import { actionTypes } from "../actions/types";

const WinnersReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_WINNERS:
      return action.payload;
    default:
      return state;
  }
};

export default WinnersReducer;
